var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ChangeDetectorRef, Compiler, Component, ElementRef, Inject, Injector, Input, ViewChild, } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { EntityComparisonHelper } from '@synisys/idm-de-core-frontend';
import { DeSerializationService, DeService, MainEntity, } from '@synisys/idm-de-service-client-js';
import { formModuleRegistryKey, FormService, FormType, ModuleRegistryService, } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { LockingService } from '@synisys/idm-lock-service-client-js';
import { LanguageService, MessageService, } from '@synisys/idm-message-language-service-client-js';
import { CurrentLanguageProvider, EventBase, } from '@synisys/idm-session-data-provider-api-js';
import { ActionService, } from '@synisys/idm-workflow-service-client-js';
import { concat, isNil, flatten, uniq } from 'lodash';
import { Debounce } from 'lodash-decorators';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { noop } from 'rxjs/util/noop';
import { NotificationModel } from '../../concepts';
import { ActionBuilder, ContextArg, ContextArgEnum, ContextArgument, FieldArgument, StateArgument, } from '../../service/layout-actions';
import { ActionResolverService, DynamicFormClassifiersService, DynamicFormDocumentsService, DynamicFormKbService, DynamicFormMainDeService, DynamicFormPopupsService, DynamicFormUtilitiesService, } from '../../service/local';
import { DynamicFormNavigationsService } from '../../service/local/dynamic-form-navigations.service';
import { DynamicFormWorkflowService } from '../../service/local/dynamic-form-workflow.service';
import { TabIndexService } from '../../service/local/tab-index.service';
import { MetaFormModel } from '../../service/model/meta-form.model';
import { DynamicFormLayout } from '../dynamic-form-layout';
import { DynamicLayoutType } from '../dynamic-layout';
import './form.component.scss';
import { Access, AuthorizationService, } from '@synisys/idm-authorization-client-js';
import { AuthenticationService, } from '@synisys/idm-authentication-client-js';
import { DynamicArgumentType, DYNAMIC_ACTION_CONTAINERS, getDynamicActions, } from '@synisys/idm-dynamic-controls-metadata';
var DynamicFormComponent = /** @class */ (function (_super) {
    __extends(DynamicFormComponent, _super);
    function DynamicFormComponent(languageService, currentLanguageProvider, _actionService, formService, dialog, activatedRouter, lockService, actionResolverService, injector, changeDetector, compiler, messageService, deSerializationService, _deService, _authorizationService, _authenticationService, kbService, innerActionsContainer, moduleRegistryService, eventBase) {
        var _this = _super.call(this) || this;
        _this.languageService = languageService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this._actionService = _actionService;
        _this.formService = formService;
        _this.dialog = dialog;
        _this.activatedRouter = activatedRouter;
        _this.lockService = lockService;
        _this.actionResolverService = actionResolverService;
        _this.injector = injector;
        _this.changeDetector = changeDetector;
        _this.compiler = compiler;
        _this.messageService = messageService;
        _this.deSerializationService = deSerializationService;
        _this._deService = _deService;
        _this._authorizationService = _authorizationService;
        _this._authenticationService = _authenticationService;
        _this.kbService = kbService;
        _this.innerActionsContainer = innerActionsContainer;
        _this.moduleRegistryService = moduleRegistryService;
        _this.eventBase = eventBase;
        _this.headerHeight = 0;
        _this.layoutActions = [];
        _this.containerType = undefined;
        _this.hasSubwayViewPermission = false;
        _this.formLoadingShow = false;
        _this.formLoadingFreeze = false;
        _this.formLoadingSuccess = false;
        _this.formLoadingFail = false;
        _this.headerToggled = false;
        _this.temporaryDocuments = new Set();
        _this.temporaryDocumentsOld = [];
        _this.actions = {};
        _this.lastScroll = 0;
        _this._validations = [];
        _this._isHeaderHidden = false;
        _this._inDrawer = false;
        _this._isReady = false;
        _this._workflowActions = [];
        _this.entityComparisionHelper = new EntityComparisonHelper(kbService);
        return _this;
    }
    DynamicFormComponent_1 = DynamicFormComponent;
    Object.defineProperty(DynamicFormComponent.prototype, "isHeaderHidden", {
        get: function () {
            return this._isHeaderHidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "thisRef", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "inDrawer", {
        get: function () {
            return this._inDrawer;
        },
        set: function (value) {
            this._inDrawer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "languages", {
        get: function () {
            return this.metaForm.languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "currentLanguage", {
        get: function () {
            return this._currentLanguage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "workflowActions", {
        get: function () {
            return this._workflowActions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "categorySystemName", {
        get: function () {
            return this.categoryName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "queryParams", {
        get: function () {
            return this._queryParams;
        },
        enumerable: true,
        configurable: true
    });
    DynamicFormComponent.prototype.setMainEntityValidations = function (validations) {
        this._validations = validations;
        this.validationsChanged.next(this._validations);
    };
    DynamicFormComponent.prototype.getValidations = function () {
        return this._validations;
    };
    DynamicFormComponent.prototype.setPopupValidations = function (validations) {
        this.activePopup.popUpValidations = validations;
    };
    DynamicFormComponent.prototype.getEntity = function () {
        return this.entity;
    };
    DynamicFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._queryParams = Object.assign({}, this.activatedRouter.snapshot.queryParams);
        if (!this._queryParams.hasOwnProperty('isOffline')) {
            this._queryParams['isOffline'] = 'false';
        }
        DynamicFormComponent_1.QUERY_PARAMS = this._queryParams;
        this.categoryName = this.metaForm.layoutModel.category;
        this.emptyEntity = this.entity.clone();
        this.oldEntity = this.entity.clone();
        this.initCurrentLanguage()
            .pipe(switchMap(function (currentLanguage) {
            _this._currentLanguage = currentLanguage;
            return _this.settlePermissions();
        }), takeUntil(this.destroySubject$))
            .subscribe(function () {
            _this.collectActionsMeta();
            _this.initEnvironment();
            _this._isReady = true;
        }, function (err) { return console.error(err); });
    };
    DynamicFormComponent.prototype.ngAfterViewChecked = function () {
        if (this._isReady &&
            this.elementView &&
            this.elementView.nativeElement &&
            this.elementView.nativeElement.offsetHeight &&
            this.headerHeight !== this.elementView.nativeElement.offsetHeight) {
            this.headerHeight = this.elementView.nativeElement.offsetHeight;
            this.changeDetector.detectChanges();
        }
    };
    DynamicFormComponent.prototype.getControlStyle = function (control) {
        return control && control.properties.generalProperties.has('style')
            ? control.properties.generalProperties
                .get('style')['classes'].join(' ')
            : '';
    };
    DynamicFormComponent.prototype.getCurrentLanguage = function () {
        return this._currentLanguage;
    };
    DynamicFormComponent.prototype.showHideHeader = function (event) {
        var targetElement = event.target;
        this._isHeaderHidden =
            targetElement.scrollTop > 68 &&
                targetElement.scrollTop > this.lastScroll;
        this.lastScroll = targetElement.scrollTop;
    };
    DynamicFormComponent.prototype.ngOnChanges = function (changes) {
        if (this.isReady) {
            if (changes['entity']) {
                this.initEnvironment();
            }
            if (changes['metaForm']) {
                this.initEnvironment();
            }
        }
    };
    DynamicFormComponent.prototype.isForm = function () {
        return true;
    };
    DynamicFormComponent.prototype.ngOnDestroy = function () {
        this.removeLock().subscribe(noop, console.error);
        if (this._runtimeRef) {
            this._runtimeRef.destroy();
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    DynamicFormComponent.prototype.removeLock = function () {
        var entityInstanceId = this.entity.getInstanceId();
        if (entityInstanceId !== null &&
            entityInstanceId !== undefined &&
            this.metaForm.formType === FormType.EDIT) {
            return this.lockService.removeLock(this.metaForm.layoutModel.category, entityInstanceId);
        }
        return of(true);
    };
    DynamicFormComponent.prototype.toggleHeader = function () {
        this.headerToggled = !this.headerToggled;
    };
    DynamicFormComponent.prototype.showNotification = function (messageKey, mode, modeMessageKey) {
        if (!this.notification) {
            this.notification = new NotificationModel();
        }
        return this.notification.loadAndShow(messageKey, mode, modeMessageKey, this.messageService);
    };
    DynamicFormComponent.prototype.showNotificationWithPlaceHolder = function (messageKey, mode, placeholders, modeMessageKey) {
        if (!this.notification) {
            this.notification = new NotificationModel();
        }
        return this.notification.loadAndShow(messageKey, mode, modeMessageKey, this.messageService, placeholders);
    };
    DynamicFormComponent.prototype.addRuntimeComponent = function (controlModel, moduleType, component, cellTitle, tabId) {
        var _this = this;
        var layout = this;
        this._moduleSet.add(moduleType);
        /* tslint:disable:max-classes-per-file*/
        var cmpClass = /** @class */ (function () {
            function RuntimeComponent() {
                this.category = layout.metaForm.layoutModel.category;
                this.form = layout;
                this.queryParams = layout._queryParams;
                this.actions = layout.actions;
                this.languages = layout.languages;
                // public item = item;
                this.cellId = controlModel.id;
                this.title = cellTitle;
                this.controlId = controlModel.id;
                this.tabId = tabId;
                this.transientFields = layout.transientFields;
                this.actionNotifier = layout.actionNotifier;
                this.popupEditMode = layout.popupEditMode;
                this.contextCategory = this.category;
                this.layoutType = DynamicLayoutType.form;
                this.formType = layout.metaForm.formType;
                this.isRequired = layout.isControllerRequiredToSet(controlModel);
                this.containerType = layout.containerType;
            }
            Object.defineProperty(RuntimeComponent.prototype, "filters", {
                get: function () {
                    return layout.activatedRouter.snapshot.queryParams['filters'];
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "workflowActions", {
                get: function () {
                    return this.form.workflowActions;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "entity", {
                get: function () {
                    return this.form.entity;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "dePermissionModel", {
                get: function () {
                    return this.form.metaForm.dePermission;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "isreadonly", {
                get: function () {
                    return (controlModel.properties.generalProperties.get('isreadonly'));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "isReadonly", {
                get: function () {
                    return (controlModel.properties.generalProperties.get('isReadonly'));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "contextEntity", {
                get: function () {
                    return this.form.entity;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "validations", {
                get: function () {
                    return this.form._validations;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "currentLanguageId", {
                get: function () {
                    return layout.currentLanguage.getId();
                },
                enumerable: true,
                configurable: true
            });
            return RuntimeComponent;
        }());
        /* tslint:enable:max-classes-per-file*/
        Component(component)(cmpClass);
        this._componentCache.set(controlModel.id, cmpClass);
        if (this._componentCache.size === this._countOfControls) {
            this.layoutActions.forEach(function (layoutAction) {
                _this.actions[layoutAction.name] = layoutAction.func;
            });
            this.loadRuntimeModule().subscribe(function () {
                _this.initDynamicActions(_this.getRuntimeModuleRef().injector);
            }, console.error);
        }
    };
    DynamicFormComponent.prototype.getLayoutActions = function () {
        return this.layoutActions;
    };
    DynamicFormComponent.prototype.getActionNotifier = function () {
        return this.actionNotifier;
    };
    DynamicFormComponent.prototype.getPredicateContext = function () {
        return {
            entity: this.entity,
            actions: this.actions,
            item: undefined,
            popupEditMode: this.popupEditMode,
            queryParams: this._queryParams,
            isEditForm: this.metaForm.formType === FormType.EDIT,
        };
    };
    DynamicFormComponent.prototype.getInitialTabId = function () {
        var tabId = 0;
        if (this.inDrawer) {
            tabId = this.transientFields['tabId'];
        }
        return tabId;
    };
    DynamicFormComponent.prototype.getMetaForm = function () {
        return this.metaForm;
    };
    DynamicFormComponent.prototype.isSubForm = function () {
        return false;
    };
    DynamicFormComponent.prototype.dynamicLayoutType = function () {
        return DynamicLayoutType.form;
    };
    DynamicFormComponent.prototype.getModuleRegistryService = function () {
        return this.moduleRegistryService;
    };
    DynamicFormComponent.prototype.trackByFunc = function (index, row) {
        return row.id;
    };
    DynamicFormComponent.prototype.noChanges = function () {
        if (this.metaForm.formType === FormType.EDIT) {
            return Observable.fromPromise(this.entityComparisionHelper.equals(this.metaForm.layoutModel.category, this.entity, this.oldEntity));
        }
        return Observable.of(true);
    };
    DynamicFormComponent.prototype.resetEntity = function () {
        this.entity = this.oldEntity.clone();
    };
    DynamicFormComponent.prototype.cleanEntity = function () {
        this.entity = this.emptyEntity.clone();
    };
    DynamicFormComponent.prototype.initWorkflowActions = function () {
        var _this = this;
        var wfStateMetaField = this.metaForm.wfStateMetaField;
        if (!wfStateMetaField) {
            this._workflowActions = [];
            return;
        }
        var wfState = this.entity.getProperty(wfStateMetaField.getSystemName());
        if (wfState.value === null) {
            return;
        }
        this._deService
            .getPermittedActions(this.metaForm.layoutModel.category, this.entity.getInstanceId())
            .pipe(tap(function (actionDtos) {
            return (_this._workflowActions = actionDtos);
        }), takeUntil(this.destroySubject$))
            .subscribe(noop, console.error);
    };
    DynamicFormComponent.prototype.resetForm = function () {
        var _this = this;
        this.initEnvironment();
        this._isReady = false;
        setTimeout(function () { return (_this._isReady = true); });
    };
    DynamicFormComponent.prototype.initDynamicActions = function (injector) {
        var _this = this;
        this.getAllActionContainers().forEach(function (container) {
            var ctx = injector.get(container);
            var metaActions = getDynamicActions(container['prototype']);
            if (!isNil(metaActions)) {
                metaActions.forEach(function (metaAction) {
                    _this.actions[metaAction.actionName] = isNil(ctx)
                        ? container['prototype'][metaAction.actionName]
                        : container['prototype'][metaAction.actionName].bind(ctx);
                });
            }
        });
    };
    DynamicFormComponent.prototype.publishEvent = function (messageKey, mode, modeMessageKey, placeholders) {
        this.eventBase.publish('show-notification-toast', {
            messageKey: messageKey,
            mode: mode,
            modeMessageKey: modeMessageKey,
            placeholders: placeholders,
        });
    };
    DynamicFormComponent.prototype.collectActionsMeta = function () {
        var _this = this;
        this.layoutActions = concat(this.layoutActions, this.actionResolverService.getAction());
        this.layoutActions.push(new ActionBuilder()
            .name('isViewForm')
            .params([])
            .action(function () { return _this.metaForm.formType === FormType.VIEW; })
            .build());
        this.layoutActions.push(new ActionBuilder()
            .name('nop')
            .params([])
            .action(function () { })
            .build());
        this.layoutActions.push(new ActionBuilder()
            .name('toggleHeader')
            .params([])
            .action(function () {
            _this.toggleHeader();
        })
            .build());
        this.layoutActions.push(new ActionBuilder()
            .name('validationEmittedFor')
            .params([ContextArg(ContextArgEnum.CONTROLLER_ID)])
            .action(function (controlId) { })
            .build());
        this.getAllActionContainers().forEach(function (container) {
            var metaActions = getDynamicActions(container['prototype']);
            if (!isNil(metaActions)) {
                (_a = _this.layoutActions).push.apply(_a, metaActions.map(_this.metaActionToLayoutAction));
            }
            var _a;
        });
    };
    DynamicFormComponent.prototype.getAllActionContainers = function () {
        return uniq(flatten(this.innerActionsContainer));
    };
    DynamicFormComponent.prototype.metaActionToLayoutAction = function (metaDynamicAction) {
        var params = metaDynamicAction.params.map(function (metaParam) {
            if (metaParam.type === DynamicArgumentType.Field) {
                return new FieldArgument(metaParam.value);
            }
            else if (metaParam.type === DynamicArgumentType.Context) {
                return new ContextArgument(metaParam.value);
            }
            else {
                return new StateArgument(metaParam.value);
            }
        });
        return new ActionBuilder()
            .name(metaDynamicAction.actionName)
            .params(params.slice())
            .async(metaDynamicAction.async)
            .action(metaDynamicAction.descriptor.value)
            .build();
    };
    DynamicFormComponent.prototype.settlePermissions = function () {
        var _this = this;
        return this._authenticationService.getUserData().pipe(switchMap(function (userData) {
            return _this._authorizationService.getPermissionAccessValue(userData.userId, 'a6421559-eb8c-cb4b-0658-6e99f0872186');
        }), map(function (permissionValue) {
            _this.hasSubwayViewPermission =
                permissionValue.access === Access.FULL;
        }));
    };
    DynamicFormComponent.prototype.initCurrentLanguage = function () {
        return this.currentLanguageProvider.getCurrentLanguage();
    };
    DynamicFormComponent.prototype.initEnvironment = function () {
        this._countOfControls = this.countNumberOfControls();
        this._moduleSet = new Set();
        this._componentCache = new Map();
    };
    DynamicFormComponent.QUERY_PARAMS = undefined;
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DynamicFormComponent.prototype, "inDrawer", null);
    __decorate([
        ViewChild('header'),
        __metadata("design:type", ElementRef)
    ], DynamicFormComponent.prototype, "elementView", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DynamicFormComponent.prototype, "layoutActions", void 0);
    __decorate([
        Input(),
        __metadata("design:type", MainEntity)
    ], DynamicFormComponent.prototype, "entity", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DynamicFormComponent.prototype, "transientFields", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Subject)
    ], DynamicFormComponent.prototype, "actionNotifier", void 0);
    __decorate([
        Input(),
        __metadata("design:type", MetaFormModel)
    ], DynamicFormComponent.prototype, "metaForm", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DynamicFormComponent.prototype, "containerType", void 0);
    __decorate([
        Debounce(50, { leading: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DynamicFormComponent.prototype, "initWorkflowActions", null);
    DynamicFormComponent = DynamicFormComponent_1 = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'dynamic-form',
            template: require('./form.component.html'),
            providers: [
                DynamicFormClassifiersService,
                DynamicFormPopupsService,
                DynamicFormMainDeService,
                DynamicFormDocumentsService,
                DynamicFormNavigationsService,
                DynamicFormUtilitiesService,
                DynamicFormWorkflowService,
                DynamicFormKbService,
                ActionResolverService,
                TabIndexService,
            ],
        }),
        __param(0, Inject(LanguageService)),
        __param(17, Inject(DYNAMIC_ACTION_CONTAINERS)),
        __param(18, Inject(formModuleRegistryKey)),
        __metadata("design:paramtypes", [LanguageService,
            CurrentLanguageProvider,
            ActionService,
            FormService,
            MatDialog,
            ActivatedRoute,
            LockingService,
            ActionResolverService,
            Injector,
            ChangeDetectorRef,
            Compiler,
            MessageService,
            DeSerializationService,
            DeService,
            AuthorizationService,
            AuthenticationService,
            KbService, Array, ModuleRegistryService,
            EventBase])
    ], DynamicFormComponent);
    return DynamicFormComponent;
    var DynamicFormComponent_1;
}(DynamicFormLayout));
export { DynamicFormComponent };
//# sourceMappingURL=form.component.js.map